import { addTranslation, setTankerProjectId } from '@ps-int/react-tanker';

import { TANKER_PROJECT_ID } from '../../../common/const/tanker-name';
import { SupportedLang } from '../../../types/common';

let appLang: SupportedLang = 'ru';

/**
 * Возвращает текущий язык приложения
 *
 * @returns {SupportedLang}
 */
export const getAppLang = () => appLang;

/**
 * Инициализирует i18n в приложении
 *
 * @param {SupportedLang} [_lang]
 */
export const initI18N = (_lang?: SupportedLang): void => {
    setTankerProjectId(TANKER_PROJECT_ID);

    appLang = LANG as SupportedLang;
    addTranslation(LANG, require(`../../../i18n/${LANG}`));
};
